import InsightsPage from '@/modules/insights/InsightsPage';
import { useStore } from 'vuex';
import { isInternalUser } from '@nova/core';
import i18n from '@/plugins/i18n.js';

export default [
  {
    path: '/insights',
    name: 'insights',
    component: InsightsPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.insights'),
      requiresAuth: true
    },
    // This might be better suited in the main routes file
    // But that file does not have the context it needs to do this
    // This will make sure that any internal users that were redirected from the home page "/"
    // Will be taken to the internalHome page instead of this page (insights).
    beforeEnter: async (to, from, next) => {
      const store = useStore();
      if (isInternalUser(store.state.Auth.me)) {
        next({ name: 'internalHome' });
        return;
      }

      next();
    }
  },
  {
    path: '/insights/carrier',
    name: 'insights.carrier',
    component: InsightsPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.carrierInsights'),
      requiresAuth: true
    },
    beforeEnter: async (to, from, next) => {
      const store = useStore();
      if (isInternalUser(store.state.Auth.me)) {
        next({ name: 'insights' });
        return;
      }

      next();
    }
  },
  {
    path: '/insights/warehouse',
    name: 'insights.warehouse',
    component: InsightsPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.warehouseInsights'),
      requiresAuth: true
    },
    beforeEnter: async (to, from, next) => {
      const store = useStore();
      if (isInternalUser(store.state.Auth.me)) {
        next({ name: 'insights' });
        return;
      }

      next();
    }
  },
  {
    path: '/insights/reporting',
    name: 'insights.reporting',
    component: InsightsPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.reporting'),
      requiresAuth: true
    },
    beforeEnter: async (to, from, next) => {
      const store = useStore();
      if (isInternalUser(store.state.Auth.me)) {
        next({ name: 'insights' });
        return;
      }

      next();
    }
  }
];
